import React, { Component } from 'react';
import { connect } from 'react-redux';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
//import IconButton from '@material-ui/core/IconButton';
//import AppBar from '@material-ui/core/AppBar';
//import Toolbar from '@material-ui/core/Toolbar';

import ManageUserListItem from './ManageUserListItem';
import userActions from '../actions/user_actions';


export class ManageUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //members: this.props.members,
      selectedUser: {},
      checked: [0],
      setChecked: [0],
      canManageChecked: false,
      // canViewLogsChecked: false
    };
  }

  // BUG TODO: fix to roles.includes("A"), "V" for view log files?
  handleSelectedUserCallback = (selectedUser) => {
    this.setState({ selectedUser: selectedUser }, () => {
      console.log("[ManageUser] this.state.selectedUser: ", this.state.selectedUser);
      var userRole = selectedUser.roles ? selectedUser.roles : "";
      if (userRole.includes("A")) {
        this.setState({ canManageChecked: true });
      } else if (userRole.includes("D")) {
        this.setState({ canManageChecked: true });
      } else {
        this.setState({ canManageChecked: false });
      }
    });
  };

  changeRole = (property, role) => {
      console.log("Changing Role...");
      let newSelectedUser = this.state.selectedUser;
      if (newSelectedUser[property] !== null && newSelectedUser[property] !== undefined) {
          if (!newSelectedUser[property].includes(role)) {
              // adding roles
              if (newSelectedUser[property] === " " || newSelectedUser[property] === "") {
                  newSelectedUser[property] = role;
              } else {
                  newSelectedUser[property] += role;
              }
              this.handleSelectedUserCallback(newSelectedUser);
          } else {
              // removing roles
              var roles = newSelectedUser[property];
              roles = roles.split(role).join("");
              console.log("roles...");
              console.log(roles);
              newSelectedUser[property] = roles;
              this.handleSelectedUserCallback(newSelectedUser);
          }
      } else {
          newSelectedUser[property] = role;
      }
      return newSelectedUser;
  }
  // BUG: handle change for each textfield
  handleChange = (property, role = undefined) => event => {
    console.log("Attempting to change");
    let newSelectedUser = this.state.selectedUser;
      if (property === "roles") {
          if (newSelectedUser.firstName !== undefined && newSelectedUser.firstName !== null)
              newSelectedUser = this.changeRole(property, role);
    } else {
        newSelectedUser[property] = event.target.value;
    }
    this.setState({ selectedUser: newSelectedUser }, () => {
    });
  };

  // TODO: handle checkmark?
  canManageChecked = (value) => {
    console.log("canManageChecked");
    if (this.state.canManageChecked === true)
        this.setState({ canManageChecked: false });
    else 
        this.setState({ canManageChecked: true });
  };

  // TODO: handle checkmark?
    canViewLogsChecked = (value) => {
      /*
      console.log("canViewLogsChecked");
      if (this.state.canViewLogsChecked === true)
        this.setState({ canViewLogsChecked: false });
      else
        this.setState({ canViewLogsChecked: true });
      */
  };

  handlecanManageToggle = () => {
    // this.props.toggleUser(this.props.memberNameMap[value]['id'], this.state.company);
    /*
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    console.log("NEW CHECKED", newChecked);
    this.setState({
      checked: newChecked,
    });
    */
    this.setState({ canManageChecked: !this.state.canManageChecked });
  };

  handlecanViewLogsToggle = () => {
    // this.props.toggleUser(this.props.memberNameMap[value]['id'], this.state.company);
    /*
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    console.log("NEW CHECKED", newChecked);
    this.setState({
      checked: newChecked,
    });
    */
    // this.setState({ canViewLogsChecked: !this.state.canViewLogsChecked });
  };

  // removes a user
  handleRmoveUser = () => {
    console.log("handleRemoveUser");
    console.log(this.state.selectedUser);
    this.props.deleteManageUser({
      'id': this.state.selectedUser.id
    });
    this.setState({ selectedUser: { email: "", firstName: "", lastName: "", extension: "", roles: "", newPassword: "" } });
    this.setState({ canManageChecked: false });
  };

  // creates a new user
  handleCreateUser = () => {
    console.log("handleCreateUser");
    var roles = this.state.selectedUser.roles !== undefined && this.state.selectedUser.roles !== null ? this.state.selectedUser.roles : "O";
    if (this.state.canManageChecked && !roles.includes("A")) {
      roles += "A";
    }
    console.log(this.state.selectedUser);
    this.props.createManageUser({
      'email': this.state.selectedUser.email,
      'firstName': this.state.selectedUser.firstName,
      'lastName': this.state.selectedUser.lastName,
      'extension': this.state.selectedUser.extension,
      'roles': roles,
      'newPassword': this.state.selectedUser.password
    });
    this.setState({ selectedUser: { email: "", firstName: "", lastName: "", extension: "", roles: "", newPassword: "" } });
    this.setState({ canManageChecked: false });
  };

  // save the changes made to exisiting user
  handleSaveUser = () => {
    console.log("handleSaveUser");
    console.log(this.state.selectedUser);
    var roles = this.state.selectedUser.roles ? this.state.selectedUser.roles : "";
    if (this.state.canManageChecked && !roles.includes("A")) {
        roles += "A";
    } 
    if (!this.state.canManageChecked && roles.includes("A")) {
        roles = roles.split("A").join("");
    }
    this.props.updateManageUser({
      'id': this.state.selectedUser.id,
      'email': this.state.selectedUser.email,
      'firstName': this.state.selectedUser.firstName,
      'lastName': this.state.selectedUser.lastName,
      'extension': this.state.selectedUser.extension,
      'roles': roles,
      'newPassword': this.state.selectedUser.password
    });
  };

  render() {
    console.log("props: ", this.props);
    console.log("this.state.selectedUser", this.state.selectedUser);
    const userManagerList = [];
    let removeButton;

    this.props.members.map((member) => {
      userManagerList.push(
        <ManageUserListItem
          member={member}
          key={member.id}
          callbackFromParent={this.handleSelectedUserCallback}
        />
      );
    });
    
    if (Object.keys(this.state.selectedUser).length === 0 && this.state.selectedUser.constructor === Object) {
      removeButton =
        <Button variant="contained" disabled color="primary">
          Remove User
        </Button>;
    } else {
      removeButton =
        <Button variant="contained" onClick={this.handleRmoveUser} color="primary">
          Remove User
        </Button>;
    }
    return (
        <div>
            <Grid style={{ height: '100%', backgroundColor: '#f5f5f5' }} container spacing={0} direction="row" justifyContent="center" alignItems="center">
            {/*User List*/}
            <Grid item xs={6} style={{ height: '100%', paddingRight: '5px', paddingLeft: '10px', paddingTop: '10px', paddingBottom: '10px' }}>
              <Card style={{ height: '100%', padding: '10px', overflowY: 'scroll', overflowX: 'hidden' }}>
              <Grid container item xs={12} style={{ maxHeight: '490px', paddingBottom: '10px' }}>
                <Grid item xs={12}><Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>User List</Typography></Grid>
                <Grid item xs={6}><Typography style={{ fontSize: '12px', fontWeight: 'bold', color: '#3f51b5' }}>User Name</Typography></Grid>
                <Grid item xs={6}><Typography align="left" style={{ fontSize: '12px', fontWeight: 'bold', color: '#3f51b5', textAlign: 'center' }}>Can Manage</Typography></Grid>
                {/*<Grid item xs={3}><Typography align="left" style={{ fontSize: '12px', fontWeight: 'bold', color: '#3f51b5' }}>Can View Log</Typography></Grid>*/}
                  <Grid item xs={12} style={{ }}>
                  <List style={{ maxHeight: '490px' }}>
                    {userManagerList}
                  </List>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/*User Information & Add User*/}
            <Grid item xs={6} style={{ height: '100%', paddingLeft: '5px', paddingRight: '10px', paddingTop: '10px', paddingBottom: '10px' }}>
              <Card className="userInfo" style={{ height: '100%', padding: '10px', overflowY: 'scroll', overflowX: 'hidden' }}>
              <Grid container item xs={12} style={{ maxHeight: '490px', paddingBottom: '10px' }}>
                <Grid item xs={12}>
                  <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>User Information</Typography>
                </Grid>

                <Grid container item xs={12}>
                  <Typography align="left" style={{ fontWeight: 'bold', color: '#3f51b5' }}>First Name</Typography>
                  <Grid item xs={12}>
                    <TextField
                      // autoFocus
                      margin="normal"
                      id="firstName"
                      type="name"
                      value={this.state.selectedUser.firstName}
                      onChange={this.handleChange('firstName')}
                      fullWidth
                      style={{}}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Typography align="left" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Last Name</Typography>
                  <TextField
                    // autoFocus
                    margin="normal"
                    id="lastName"
                    type="name"
                    value={this.state.selectedUser.lastName}
                    onChange={this.handleChange('lastName')}
                    fullWidth
                    style={{}}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography align="left" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Extension</Typography>
                  <TextField
                    // autoFocus
                    margin="normal"
                    id="extension"
                    type="name"
                    value={this.state.selectedUser.extension}
                    onChange={this.handleChange('extension')}
                    fullWidth
                    style={{}}
                  />
                </Grid>

                <Grid item xs={12}>
                    <Typography align="left" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Role</Typography>
                    <List>
                    <ListItem role={undefined} dense button onClick={this.handleChange('roles', 'S')} style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                            <ListItemIcon style={{ margin: '0px' }}>
                                <Checkbox
                                    edge="start"
                                    checked={this.state.selectedUser.roles ? this.state.selectedUser.roles.includes("S") : false}
                                    tabIndex={-1}
                                    disableRipple
                                />
                            </ListItemIcon>
                            <ListItemText primary={`Sales`} style={{ fontSize: '12px' }} />
                    </ListItem>
                    <ListItem role={undefined} dense button onClick={this.handleChange('roles', 'D')} style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                            <ListItemIcon style={{ margin: '0px' }}>
                                <Checkbox
                                    edge="start"
                                    checked={this.state.selectedUser.roles ? this.state.selectedUser.roles.includes("D") : false}
                                    tabIndex={-1}
                                    disableRipple
                                />
                            </ListItemIcon>
                            <ListItemText primary={`Development`} style={{ fontSize: '12px' }} />
                        </ListItem>
                        <ListItem role={undefined} dense button onClick={this.handleChange('roles', 'A')} style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                            <ListItemIcon style={{ margin: '0px' }}>
                                <Checkbox
                                    edge="start"
                                    checked={this.state.selectedUser.roles ? this.state.selectedUser.roles.includes("A") : false}
                                    tabIndex={-1}
                                    disableRipple
                                />
                            </ListItemIcon>
                            <ListItemText primary={`Admin`} style={{ fontSize: '12px' }} />
                        </ListItem>
                        <ListItem role={undefined} dense button onClick={this.handleChange('roles', 'O')} style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                            <ListItemIcon style={{ margin: '0px' }}>
                                <Checkbox
                                    edge="start"
                                    checked={this.state.selectedUser.roles ? this.state.selectedUser.roles.includes("O") : false}
                                    tabIndex={-1}
                                    disableRipple
                                />
                            </ListItemIcon>
                            <ListItemText primary={`Other`} style={{ fontSize: '12px' }} />
                        </ListItem>
                    </List>
                </Grid>

                <Grid item xs={12}>
                  <Typography align="left" style={{ fontWeight: 'bold', color: '#3f51b5' }}>Email</Typography>
                  <TextField
                    // autoFocus
                    margin="normal"
                    id="email"
                    type="name"
                    value={this.state.selectedUser.email}
                    onChange={this.handleChange('email')}
                    fullWidth
                    style={{}}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography align="left" style={{ fontWeight: 'bold', color: '#3f51b5' }}>New Password</Typography>
                  <TextField
                    // autoFocus
                    margin="normal"
                    id="password"
                    type="name"
                    value={this.state.selectedUser.password} // how to hash it?
                    onChange={this.handleChange('password')}
                    fullWidth
                    style={{}}
                  />
                </Grid>

                <Grid item xs={12}>
                  <List>
                    <ListItem role={undefined} dense button onClick={this.handlecanManageToggle} style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                      <ListItemIcon style={{ margin: '0px' }}>
                        <Checkbox
                          edge="start"
                          //checked={checked.indexOf(value) !== -1}
                          checked={this.state.canManageChecked}
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText primary={`Allow the ability to manage users`} style={{ fontSize: '12px' }} />
                    </ListItem>
                    {/*
                    <ListItem role={undefined} dense button onClick={this.handlecanViewLogsToggle} style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                     <ListItemIcon style={{ margin: '0px' }}>
                     <Checkbox
                        edge="start"
                        //checked={checked.indexOf(value) !== -1}
                        checked={this.state.canViewLogsChecked}
                        tabIndex={-1}
                        disableRipple
                      />
                      </ListItemIcon>
                      <ListItemText primary={`Allow the ability to view log files`} style={{ fontSize: '12px' }} />
                    </ListItem>
                    */}
                  </List>
                </Grid>

                <Grid container item xs={12} style={{ width: '100%', paddingBottom: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                  <Grid item>
                    {removeButton}
                  </Grid>
                  <Grid item>
                    <Button variant="contained" onClick={this.handleSaveUser} color="primary">
                      Save Changes
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="contained" onClick={this.handleCreateUser} color="primary">
                      Add New User
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    members: state.members,
    profile: state.profile,
    currentUser: state.currentUser,
    memberIdMap: state.memberIdMap,
    memberNameMap: state.memberNameMap,
  };
}

const mapDispatchToProps = dispatch => ({
  updateManageUser: user => dispatch(userActions['UPDATE_MANAGE_USER'](user)),
  createManageUser: user => dispatch(userActions['CREATE_MANAGE_USER'](user)),
  deleteManageUser: user => dispatch(userActions['DELETE_MANAGE_USER'](user))
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageUser);


// WEBPACK FOOTER //
// ./src/components/ManageUser.js